<template>
    <!-- 这里父元素使用display:flex样式，子元素设置flex时宽度可撑满整个浏览器 -->
    <div style="display:flex;">
        <div style="float:left;width:300px;border-right:1px solid #409EFF;">
            <el-menu :default-active="activeIndex" @select="handleSelect" class="pain_list">
                <el-menu-item :index="painspot.name" :key="index" v-for="(painspot, index) in painspot_info" style="text-align:left;padding-left:10px;">{{ painspot.full_name }}
                    <!-- <router-link :to="{name:'UserProfile',params:{ name: painspot.name }}">{{ painspot.full_name }}</router-link> -->
                </el-menu-item>
            </el-menu>
        </div>
        <!-- 这里使用样式flex:1，撑满整个屏幕的宽度 -->
        <div style="float:left;min-width:692px;flex:1;" v-if="results_mode=='details'">
            <div style="height:60px;text-align:left;margin-left:30px;">
                <el-button icon="el-icon-finished" type="primary" @click="submitComments" v-if="logged_role=='ceo'">提交评价</el-button>
                <el-select v-model="selected_depart" placeholder="选择部门" style="margin-left:10px;" clearable @change="ques_filter">
                    <el-option
                    v-for="(depart, index) in depart_options"
                    :key="index"
                    :label="depart"
                    :value="depart">
                    </el-option>
                </el-select>
                <el-select v-model="selected_rank" placeholder="选择职级" style="margin-left:10px;" clearable @change="ques_filter">
                    <el-option
                    v-for="(rank, index) in rank_options"
                    :key="index"
                    :label="rank"
                    :value="rank">
                    </el-option>
                </el-select>
            </div>
            <div style="min-height:400px;max-height:1000px;overflow-y:auto;text-align:left;padding-left:30px;padding-right:30px;">
                <el-collapse v-if="painspot_details.length>0">
                    <el-collapse-item :key="index" v-for="(detail, index) in painspot_details" title="" :name="index">
                        <template slot="title">
                            <span style="font-size:16px;">
                            <span>姓名：</span><span>{{ detail.name }}</span>
                            <span style="margin-left:20px;">部门：</span><span>{{ detail.department }}</span>
                            </span>
                        </template>
                        <div class="detail_content">
                            <p class="p_title">原因分析（原因投票结果）：</p>
                            <p :key="i" v-for="(reason, i) in detail.reasons" class="p_content">
                                <span v-if="detail.reasons.length>1">-</span> {{ reason }}
                            </p>
                            <!-- <ul style="list-style-type:circle;">
                                <li :key="i" v-for="(reason, i) in detail.reasons"><p class="p_content">{{ reason }}</p></li>
                            </ul> -->
                            <p class="p_title">公司/部门已经采取了哪些措施：</p>
                            <p class="p_content">{{ detail.done_measures }}</p>
                            <p class="p_title">公司/部门还需要进一步采取哪些措施：</p>
                            <p class="p_content">{{ detail.expect_measures }}</p>
                            <p class="p_title">主管未来可以采取哪些措施：</p>
                            <p class="p_content">{{ detail.future_measures }}</p>
                            <div style="margin-top:-5px;" v-if="logged_role=='ceo'">
                                <el-rate v-model="detail.rate" allow-half style="display:inline;"></el-rate>
                                <span class="rate_font" v-show="detail.rate">{{ detail.rate }}</span>
                            </div>
                            <div style="margin-top:-5px;" v-else>
                                <el-rate v-model="detail.rate" allow-half style="display:inline;" disabled></el-rate>
                                <span class="rate_font" v-show="detail.rate">{{ detail.rate }}</span>
                            </div>
                            <el-input
                            type="textarea"
                            resize="none"
                            :rows="3"
                            v-model="detail.comment"
                            placeholder="请输入评语"
                            style="margin-top:10px;"
                            v-if="logged_role=='ceo'">
                            <p class="p_title" v-if="logged_role!='ceo'">CEO评语：</p>
                            <p class="p_content" v-if="logged_role!='ceo'">{{ detail.comment }}</p>
                            </el-input>
                        </div>
                    </el-collapse-item>
                </el-collapse>
                <div v-else style="width:100%; text-align:center; margin-top:50px;"><span>暂无数据。</span></div>
            </div>          
        </div>

        <div style="float:left;min-width:692px;flex:1;" v-if="results_mode=='summary'">
            <div style="min-height:400px;max-height:1000px;overflow-y:auto;text-align:left;padding-left:30px;padding-right:30px;">
                <el-collapse v-if="Object.keys(painspot_details).length>0">
                    <el-collapse-item title="" :name="1">
                        <template slot="title">
                            <span style="font-size:16px;">
                            <span>问题现象描述：</span>
                            </span>
                        </template>
                        <div class="detail_content">
                            <p :key="i" v-for="(phenomenon, i) in painspot_details.phenomenons" class="p_content">
                                <span v-if="painspot_details.phenomenons.length>1">-</span> {{ phenomenon }}
                            </p>
                        </div>
                    </el-collapse-item>
                    <el-collapse-item title="" :name="2">
                        <template slot="title">
                            <span style="font-size:16px;">
                            <span>原因分析（原因投票结果）：</span>
                            </span>
                        </template>
                        <div class="detail_content">
                            <p :key="i" v-for="(reason, i) in painspot_details.reasons" class="p_content">
                                <span v-if="painspot_details.reasons.length>1">-</span> {{ reason }}
                            </p>
                        </div>
                    </el-collapse-item>
                    <el-collapse-item title="" :name="3">
                        <template slot="title">
                            <span style="font-size:16px;">
                            <span>公司/部门已结采取了哪些措施：</span>
                            </span>
                        </template>
                        <div class="detail_content">
                            <p :key="i" v-for="(done_measure, i) in painspot_details.done_measures" class="p_content">
                                <span v-if="painspot_details.done_measures.length>1">-</span> {{ done_measure }}
                            </p>
                        </div>
                    </el-collapse-item>
                    <el-collapse-item title="" :name="4">
                        <template slot="title">
                            <span style="font-size:16px;">
                            <span>公司/部门还需要进一步采取哪些措施：</span>
                            </span>
                        </template>
                        <div class="detail_content">
                            <p :key="i" v-for="(expect_measure, i) in painspot_details.expect_measures" class="p_content">
                                <span v-if="painspot_details.expect_measures.length>1">-</span> {{ expect_measure }}
                            </p>
                        </div>
                    </el-collapse-item>
                    <el-collapse-item title="" :name="5">
                        <template slot="title">
                            <span style="font-size:16px;">
                            <span>主管未来可以采取哪些措施：</span>
                            </span>
                        </template>
                        <div class="detail_content">
                            <p :key="i" v-for="(future_measure, i) in painspot_details.future_measures" class="p_content">
                                <span v-if="painspot_details.future_measures.length>1">-</span> {{ future_measure }}
                            </p>
                        </div>
                    </el-collapse-item>
                </el-collapse>
                <div v-else style="width:100%; text-align:center; margin-top:50px;"><span>暂无数据。</span></div>
            </div>
        </div>

        <div style="float:left;min-width:692px;flex:1;" v-if="results_mode=='top_advices'">
            <div style="min-height:400px;max-height:1000px;overflow-y:auto;text-align:left;padding-left:30px;padding-right:30px;">
                <el-table
                    :data="painspot_details"
                    style="width: 100%"
                    border
                    stripe
                    v-if="painspot_details.length>0">
                    <el-table-column
                        prop="rank"
                        label="排名"
                        min-width="10%">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="姓名"
                        min-width="90%">
                        <template slot-scope="scope">
                            <span style="font-size:16px;">
                            <span style="font-weight:bold;">{{ scope.row.name }}</span>
                            </span>
                            <el-button type="text" style="margin-left:5px;" @click="show_details(scope.row)">{{ scope.row.button_text }}</el-button>
                            <div class="detail_content" v-if="!scope.row.is_hidden" style="background-color: #fffafa;padding:5px;">
                                <p class="p_title">原因分析（原因投票结果）：</p>
                                <p :key="i" v-for="(reason, i) in scope.row.reasons" class="p_content">
                                    <span v-if="scope.row.reasons.length>1">-</span> {{ reason }}
                                </p>
                                <p class="p_title">公司/部门已经采取了哪些措施：</p>
                                <p class="p_content">{{ scope.row.done_measures }}</p>
                                <p class="p_title">公司/部门还需要进一步采取哪些措施：</p>
                                <p class="p_content">{{ scope.row.expect_measures }}</p>
                                <p class="p_title">主管未来可以采取哪些措施：</p>
                                <p class="p_content">{{ scope.row.future_measures }}</p>
                                <div style="margin-top:-5px;">
                                    <el-rate v-model="scope.row.rate" allow-half v-if="!scope.row.is_hidden" style="display:inline;" disabled></el-rate>
                                    <span class="rate_font" v-show="scope.row.rate">{{ scope.row.rate }}</span>
                                </div>
                            </div>                           
                        </template>
                    </el-table-column>
                </el-table>
                <div v-else style="width:100%; text-align:center; margin-top:50px;"><span>暂无数据。</span></div>
            </div>
        </div>
    </div>
</template>

<script>
import getdata from "@/api/getData.js";
import postdata from "@/api/postData.js";
export default {
    // created(){
    //     console.log("created.");
    // },
    // updated() {
    //     console.log("painspot_info: " + this.painspot_info);
    //     console.dir(this.painspot_details);
    // },
    // beforeUpdate() {
    //     this.get_painspot_list();
    // },
    // updated() {
    //     console.log('activeIndex in updated status: ' + this.activeIndex);
    // },
    data() {
        return {
            // activeIndex: '',
            // activeNames: [],
            // painspot_info: [
                // {'name': 'painspot1', 'full_name': 'TOP1 painspot1'},
            // ],
            // painspot_details: [
                // {'name': 'fofo1', 'department': '部门A', 'reasons': ['原因1','原因2','原因3'], 
                // 'done_measures': '已经采取的措施A', 'expect_measures': '需要采取的措施A', 
                // 'future_measures': '未来采取的措施A', 'rate': null, 'comment': ''},
            // ],
            display_val: 'painspot1',
            // depart_options: [],
            // rank_options: [],
            // topAdvicesData: [],
            selected_depart: '',
            selected_rank: '',
        }
    },
    props: ['results_mode', 'task_id', 'painspot_info', 'activeIndex', 'painspot_details', 
    'depart_options', 'rank_options', 'display_ranks', 'logged_role'],
    methods: {
        show_details(row) {
            if(row.is_hidden) {
                row.is_hidden = false;
                row.button_text = "（点击收起）";
            }else{
                row.is_hidden = true;
                row.button_text = "（点击查看详细内容）";
            }
        },
        handleSelect(index){
            this.display_val = index;
            if(this.results_mode=="details"){
                this.get_fully_data(index, "getDataDetailsByPainSpot", this.task_id);
            }else if(this.results_mode=="summary"){
                this.get_fully_data(index, "getDataSummaryByPainSpot", this.task_id);
            }else if(this.results_mode=="top_advices"){
                this.get_fully_data(index, "getDataAdvicesByPainSpot", this.task_id);
            }
        },
        // get_painspot_list(task_id, results_mode) {
        //     let params;
        //     params = {
        //         task_id: task_id,
        //     }
            
        //     getdata.getListP("getPainSpotList", params)
        //     .then(resp => {
        //         if(resp.data.code == 200){
        //             this.painspot_info = resp.data.painspot_info;
        //             this.activeIndex = this.painspot_info[0].name;      // 默认选择列表中的top1痛点
        //             // console.log('get activeIndex from father: ' + this.activeIndex);
        //             // 使用TOP1痛点获取默认详细结果数据
        //             if(results_mode=="details") {
        //                 this.get_fully_data(this.painspot_info[0].name, "getDataDetailsByPainSpot", task_id);
        //                 // console.log("call getDataDetailsByPainSpot!");
        //             }else if(results_mode=="summary") {
        //                 this.get_fully_data(this.painspot_info[0].name, "getDataSummaryByPainSpot", task_id);
        //             }else if(results_mode=="top_advices") {
        //                 this.get_fully_data(this.painspot_info[0].name, "getDataAdvicesByPainSpot", task_id);
        //             }
        //         }
        //     })
        //     .catch(err => {
        //         console.log(err);
        //     });
        // },
        ques_filter() {
            this.get_fully_data(this.activeIndex, "getDataDetailsByPainSpot", this.task_id);
        },
        get_fully_data(painspot, api_name, task_id) {
            // const loading = this.$loading({
            //     lock: true, // lock的修改符--默认是false
            //     text: '正在加载，请稍后...', // 显示在加载图标下方的加载文案
            //     spinner: 'el-icon-loading', // 自定义加载图标类名
            //     background: 'rgba(0, 0, 0, 0.7)', // 遮罩层颜色
            // })
            let params;
            params = {
                painspot: painspot,
                task_id: task_id,
                search_department: this.selected_depart,
                search_rank: this.selected_rank,
                display_ranks: this.display_ranks,
            }
            
            getdata.getListP(api_name, params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.painspot_details = resp.data.painspot_details;
                    // console.log('painspot_details: ' + this.painspot_details);
                    // if(this.results_mode=="details") {
                    //     this.depart_options = resp.data.depart_options;
                    //     this.rank_options = resp.data.rank_options;
                    // }
                }
                // loading.close();
            })
            .catch(err => {
                console.log(err);
                // loading.close();
            });
        },
        submitComments() {
            postdata.postList("submitCEOComments", JSON.stringify(this.painspot_details))
            .then(resp => {
                if(resp.data.code == 200){
                    this.$message({
                        message: resp.data.message,
                        type: "success",
                    })
                }else{
                    this.$message({
                        message: resp.data.message,
                        type: "error",
                        duration: 6000,
                        // showClose: true,
                    })
                }
                // loading.close();
            })
            .catch(err => {
                console.log(err);
                // loading.close();
            });
        },
    },
}
</script>

<style scoped>
.pain_list /deep/ .el-menu-item {
    font-size: 16px;
}
.detail_content p {
    font-size: 14px;
}
.detail_content .p_title {
    line-height: 16px;
    font-weight: 600;
}
.detail_content .p_content {
    line-height: 8px;
}
::v-deep .el-collapse-item__wrap {
    padding-left: 10px;
    padding-right: 10px;
    background-color: #fffafa;
}
::v-deep .el-rate__icon {
    font-size: 20px;
}
.el-table /deep/ th.el-table__cell {
    background-color: #f5f7fa;
}
::v-deep .el-table__header {
    width: 100%;
}
::v-deep .el-table__body {
    width: 100%;
}
::v-deep .el-collapse-item__content {
    padding-bottom: 0px;
}
.rate_font {
    color: #f7ba2a;
    font-size: 22px;
    font-weight: bold;
    position: relative;
    top: 4px;
    margin-left: 8px;
    font-style: italic;
}
</style>